import { useToastContext } from '@payaca/ambrosia';
import { useCallback } from 'react';

const useTemplateSaveErrorToast = () => {
  const { pushError } = useToastContext();

  return useCallback(
    () => pushError(`We couldn't save your changes`),
    [pushError]
  );
};

export default useTemplateSaveErrorToast;
